import { createFileRoute } from '@tanstack/react-router';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { PowerPath100Game } from '@/features/powerpath-quiz/components/PowerPath100Game';
import { PowerPathTest } from '@/features/powerpath-quiz/components/PowerPathTest';
import { useLessonType } from '@/features/powerpath-quiz/hooks';
import { LessonTypes } from '@/features/powerpath-quiz/types/powerpath-types';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute('/admin/lesson')({
  component: Lesson,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  validateSearch: (search: Record<string, unknown>) => {
    if (!search.studentId || !search.lessonId) {
      throw new Error('studentId and lessonId are required');
    }
    return {
      studentId: search.studentId as string,
      lessonId: search.lessonId as string,
    };
  },
  ssr: false,
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Admin',
    link: { to: '/admin' },
  },
  {
    label: 'Lesson',
    link: { to: '/admin/lesson' },
  },
];

function Lesson() {
  const { studentId, lessonId } = Route.useSearch();
  const { data: lessonType, isLoading } = useLessonType(lessonId);

  if (isLoading || !lessonType) {
    // TODO: Render a proper loader
    return <div>Loading...</div>;
  }

  const renderGameMode = () => {
    if (lessonType === LessonTypes.POWERPATH_100) {
      return (
        <PowerPath100Game
          key={lessonId}
          studentId={studentId}
          lessonId={lessonId}
          returnLink="/admin"
        />
      );
    } else if (
      lessonType === LessonTypes.QUIZ ||
      lessonType === LessonTypes.UNIT_TEST ||
      lessonType === LessonTypes.TEST_OUT ||
      lessonType === LessonTypes.PLACEMENT
    ) {
      return (
        <PowerPathTest
          key={lessonId}
          studentId={studentId}
          lessonId={lessonId}
          returnLink="/admin"
        />
      );
    } else {
      return <div>Unknown lesson type: {lessonType}</div>;
    }
  };

  return (
    <AdminPageContent className="overflow-hidden">
      <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      {renderGameMode()}
    </AdminPageContent>
  );
}
